import { render, staticRenderFns } from "./check-details.vue?vue&type=template&id=26aa4098"
import script from "./check-details.vue?vue&type=script&lang=js"
export * from "./check-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports